// Shared with the trusted server. A meeting link is a join URL, never a fetch target.
export function meetingLink(value) {
  if (typeof value !== 'string' || value.length > 4096) return null;
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    const host = url.hostname.toLowerCase();
    let platform = '';
    if (host === 'meet.google.com' && /^\/[a-z]{3}-[a-z]{4}-[a-z]{3}\/?$/i.test(url.pathname)) platform = 'Google Meet';
    if ((host === 'zoom.us' || host.endsWith('.zoom.us')) && /^\/(?:j|wc\/join)\/\d+\/?$/.test(url.pathname)) platform = 'Zoom';
    if (['teams.microsoft.com', 'teams.live.com', 'teams.cloud.microsoft'].includes(host) && /^\/(?:l\/meetup-join\/|meet\/)/.test(url.pathname)) platform = 'Microsoft Teams';
    if (!platform) return null;
    url.hash = '';
    return { url: url.href, platform };
  } catch { return null; }
}

export function eventMeetingLink(event) {
  const values = [event.hangoutLink, ...(event.conferenceData?.entryPoints || []).filter(p => p.entryPointType === 'video').map(p => p.uri),
    event.onlineMeeting?.joinUrl, event.onlineMeetingUrl, event.location?.displayName, typeof event.location === 'string' ? event.location : '',
    event.description, event.body?.content, event.bodyPreview];
  for (const value of values) {
    for (const candidate of String(value || '').replace(/&amp;/g, '&').match(/https:\/\/[^\s<>"']+/g) || []) {
      const link = meetingLink(candidate.replace(/[.,;)]+$/, ''));
      if (link) return link;
    }
  }
  return null;
}
